import { render, staticRenderFns } from "./modifyDialog.vue?vue&type=template&id=10157b9b&scoped=true"
import script from "./modifyDialog.vue?vue&type=script&lang=js"
export * from "./modifyDialog.vue?vue&type=script&lang=js"
import style0 from "./modifyDialog.vue?vue&type=style&index=0&id=10157b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10157b9b",
  null
  
)

export default component.exports